const BASE = '/api/backoffice/risk-model/prediction';

export class RiskModelPredictionService {
    static models = [
        {
            key: 'preApproval',
            label: 'Pre-aprobación',
            paramsPath: `${BASE}/pre-approval/params`,
            runPath: `${BASE}/pre-approval`,
        },
        {
            key: 'approval',
            label: 'Aprobación',
            paramsPath: `${BASE}/approval/params`,
            runPath: `${BASE}/approval`,
        },
        {
            key: 'amountApproval',
            label: 'Monto',
            paramsPath: `${BASE}/amount-approval/params`,
            runPath: `${BASE}/amount-approval`,
        },
        {
            key: 'default',
            label: 'Default',
            paramsPath: `${BASE}/default/params`,
            runPath: `${BASE}/default`,
        },
    ];

    static async fetchParams(modelKey, projectId) {
        const model = this.models.find((item) => item.key === modelKey);

        if (!model) {
            throw new Error(`Modelo de predicción desconocido: ${modelKey}`);
        }

        const { data } = await axios.post(model.paramsPath, { project_id: projectId });

        return data;
    }

    static async run(modelKey, projectId) {
        const model = this.models.find((item) => item.key === modelKey);

        if (!model) {
            throw new Error(`Modelo de predicción desconocido: ${modelKey}`);
        }

        const { data } = await axios.post(model.runPath, { project_id: projectId });

        return data;
    }
}
